import React from 'react';
import View from 'components/ui/view';
import Card from 'components/ui/card';
import LoadingSpinner from 'shared/components/ui/loadingSpinner';

export default function OrderLoading() {
  return (
    <View padding="md" className="order-history banner-padding">
      <Card block>
        <div
          style={{
            minHeight: '300px',
            position: 'relative',
            marginTop: '125px'
          }}
        >
          <LoadingSpinner black />
        </div>
      </Card>
    </View>
  );
}
